/**
 * Helper centralizzato per la conversione int->string al boundary
 * REST delle entita' con enum (Task.type/source/priority/status,
 * Person.leadStatus/marketingStatus/status, Business.status).
 *
 * Il backend Liferay serializza gli enum come int32. Il client espone
 * TS string union (coerenti con i label canonici del backend, vedi
 * crm-util/constants/*.java). I `*Mappers.ts` di ogni entita' usano
 * questo helper per la conversione al boundary.
 *
 * ## Perche' fallback soft + console.warn invece di throw
 *
 * Un record DB con enum int fuori-range (legacy, migrazione sporca,
 * save senza init tipo `source=null -> GetterUtil.getInteger=0` dove
 * 0 non e' nell'enum) farebbe crashare la list intera con il throw.
 * Il fallback preserva la UI viva e logga esplicitamente l'anomalia
 * cosi' il programmatore se ne accorge in console.
 *
 * ## Perche' `in` invece di `!result`
 *
 * Alcuni enum backend partono da 0 (PersonStatus.INACTIVE=0,
 * BusinessStatus.INACTIVE=0, PersonLeadStatus.NEW=0). Con `!map[0]`
 * un valore legittimo verrebbe trattato come "sconosciuto". L'operator
 * `in` distingue "chiave presente con valore falsy" da "chiave assente".
 */

export function enumFromDto<T extends string>(
  label: string,
  value: number,
  map: Record<number, T>,
  fallback: T,
): T {
  if (value in map) return map[value];
  console.warn(`[enumMapper] ${label}: int sconosciuto ${value}, fallback '${fallback}'`);
  return fallback;
}
